<template>
  <div>
    <component v-bind:is="layout"></component>

    <transition name="splash-fade">
      <div class="splash-screen" v-if="showSplash">
        <div class="splash-inner">
          <img src="images/logo/logo.png" class="splash-logo" alt="Medicater" />
          <p class="splash-brand">Medicater</p>
          <div class="splash-spinner">
            <div class="splash-ring"></div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import AppLayout from './layouts/AppLayout'
import AuthLayout from './layouts/AuthLayout'
import store from '@/store'
import swal from 'sweetalert'

export default {
  name: 'app',
  data: function () {
    return {
      loggedIn: store.state.isLoggedIn,
      showSplash: true
    }
  },
  created: function () {
    if (store.state.isLoggedIn) {
      // Show the normal page
    } else {
      this.$router.push('/login')
    }
  },
  mounted: function () {
    var that = this
    setTimeout(function () { that.showSplash = false }, 2200)

    $.showLoading()

    document.addEventListener("deviceready", function(){
        window.localStorage.setItem('review_questions', JSON.stringify([]))
        if(window.localStorage.getItem('username') != null && window.localStorage.getItem('username') != undefined && window.localStorage.getItem('password') != null && window.localStorage.getItem('password') != undefined){
          setTimeout(function(){
            that.basic_login()
          }, 100);
        }else{
          that.logout()
           $.hideLoading()
        }

        // Enables push norifications if compiled as native app
        if (typeof PushNotification !== 'undefined') {
          this.setupPush()
        }
    })

    // Configure AJAX requests with loaders, headers etc.
    $.ajaxSetup({
      async: true,
      dataType: 'json',
      beforeSend: function (xhr) {
        $.showLoading()

        if (window.localStorage.getItem('token')) {
          xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
        }
      },
      error: function (data) {
        var error = ''
        if (data.responseJSON && typeof data.responseJSON.meta.reason !== 'undefined') {
          error = data.responseJSON.meta.reason
        } else if (data.responseJSON && data.responseJSON.message !== '') {
          error = data.responseJSON.message
        } else {
          // We're probably offline
          error = 'offline'
        }
        if (error === 'offline') {
          // Do Nothing
        } else if (error === 'Your token does not appear to be valid.') {
          that.$router.push('/login')
        } else {
          swal({
            title: 'Error',
            text: error,
            icon: 'error',
            button: 'Ok'
          })
        }

        $.hideLoading()
      },
      complete: function (data) {
        /*
        if (data && data.responseText) {
          window.localStorage.setItem(this.url, data.responseText)
        }
        */

        $.hideLoading()
      }
    })
  },
  computed: {
    layout () {
      return this.$store.getters.layout
    }
  },
  components: {
    'AppLayout': AppLayout,
    'AuthLayout': AuthLayout
  },
  methods: {
     logout: function () {
      localStorage.clear()
      this.$router.push('/login')
    },
    basic_login: function () {
      var that = this
      that.errorMsg = ''
      
      var data = {
        username: window.localStorage.getItem('username'),
        password: window.localStorage.getItem('password'),
        deviceId: window.localStorage.getItem('deviceId'),
        imei: window.localStorage.getItem('imei'),
        uuid: window.localStorage.getItem('uuid'),
        device_name: window.localStorage.getItem('device_name'),
        os_version: window.localStorage.getItem('version'),
        os:cordova.platformId
      }

      if(cordova.platformId != "browser"){
          data = {
            username: window.localStorage.getItem('username'),
            password: window.localStorage.getItem('password'),
            deviceId: window.localStorage.getItem('deviceId'),
            imei: window.localStorage.getItem('imei'),
            uuid: device.uuid,
            device_name: device.manufacturer+" "+device.model,
            os_version: device.version,
            os:cordova.platformId
          }
      }

      $.ajax({
        beforeSend: function (xhr) {
          $.hideLoading()
        },
        url: this.$config.apiUrl + 'basic/login',
        type: 'post',
        data: JSON.stringify(data),
        success: function (data) {
          if (typeof data.success !== 'undefined' && data.success === true) {
            window.localStorage.setItem('user', JSON.stringify(data.data))
            window.localStorage.setItem('token', data.meta.token)
            window.localStorage.setItem('review_questions', JSON.stringify(data.data.review_questions))
            if(data.data.is_first_signup == 'Y'){
              that.$router.push('/updatePassword')
              return false
            }
          } else {
            var meta = JSON.parse(data.responseText)
            that.logout()
            that.showError(meta.meta.reason)

          }
        },
        error: function (data) {
          var meta = JSON.parse(data.responseText)
          that.logout()
          that.showError(meta.meta.reason)
          
        }
      })
     
    },
     showError: function (message) {
      this.errorMsg = message
    },
    setupPush: function () {
      // eslint-disable-next-line
      var push = PushNotification.init({
        'android': {
          'senderID': '77395875010'
        },
        'ios': {
          'sound': true,
          'alert': true,
          'badge': true
        },
        'windows': {}
      })

      push.on('registration', function (data) {
        var oldRegId = window.localStorage.getItem('deviceId')

        if (oldRegId !== data.registrationId) {
          window.localStorage.setItem('deviceId', data.registrationId)
        }

        // We also need to update it using Byron's API Call
        var token = {
          push_token: data.registrationId
        }

        window.localStorage.setItem('push_token', window.localStorage.getItem('deviceId'))

        // We wanna do this async in the background. So don't show/hide loading stuff
        $.ajax({
          url: 'https://admin.medicater.co.za/api/basic/token',
          type: 'post',
          data: JSON.stringify(token),
          beforeSend: function (xhr) {
            if (window.localStorage.getItem('token')) {
              xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
            }
          },
          error: function (data) {
            // Do nothing
          },
          complete: function () {
            // Don't unshow loading bar
          }
        })
      })

      push.on('notification', function (data) {
        navigator.notification.alert(
          data.message, // message
          null, // callback
          data.title, // title
          'Ok' // buttonName
        )
      })
    }
  }
}

</script>

<style>
/* ── Splash screen ── */
.splash-screen {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: linear-gradient(160deg, #05aceb 0%, #1a587b 50%, #0f3d5c 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.splash-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  animation: splash-rise 0.6s cubic-bezier(0.22, 1, 0.36, 1) both;
}

@keyframes splash-rise {
  from { opacity: 0; transform: translateY(24px); }
  to   { opacity: 1; transform: translateY(0); }
}

.splash-logo {
  width: 140px;
  filter: brightness(0) invert(1) drop-shadow(0 8px 24px rgba(0,0,0,0.25));
}

.splash-brand {
  font-size: 1.6rem;
  font-weight: 800;
  color: #fff;
  letter-spacing: 2px;
  text-transform: uppercase;
  opacity: 0.9;
  margin: 0;
}

.splash-spinner {
  margin-top: 8px;
}

.splash-ring {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: rgba(255,255,255,0.9);
  border-left-color: rgba(255,255,255,0.9);
  animation: splash-spin 0.9s cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite;
}

@keyframes splash-spin { to { transform: rotate(360deg); } }

/* ── Fade out transition ── */
.splash-fade-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}
.splash-fade-leave-to {
  opacity: 0;
  transform: scale(1.04);
}
</style>
